<template>
  <div class="syyq">
    <headerBlack-view></headerBlack-view>
    <div class="sddsf_menu flex-align">
      <span>首页</span>
      <div>/</div>
      <span>云桥概况</span>
      <div>/</div>
      <span>双优云桥详情</span>
    </div>
    <div class="syyq_content">
      <div class="content_top flex-align">
        <div class="left-box">
          <div class="title flex-layout">
            <img src="@/assets/yunqiao/menu.png" />
            <div class="flex-column">
              <span>双优云桥</span>
              <img src="@/assets/yunqiao/syyq.png" />
            </div>
          </div>
          <div class="pattern flex-layout">
              <div>双</div>
              <div>
                优云桥项目是首都师范大学归集内部优质资源精选一批已经获得各级领导、同行认可的社会服务类项目，通过搭建“双优云桥”平台，实现立足首都辐射全国的态势，借助首都教育远程互助北京市政府的品牌工程向有需要的地区以项目化的形态向全国提供优质资源服务。
              </div>
          </div>
          <div class="pattern flex-layout pattern2">
              <div>首</div>
              <div>都师范大学“双优云桥”项目平台将首师大内在力量汇聚，形成项目群为对口地区提供精准研修服务，
                并从教师教育能力、学校运行管理、教育决策提升等全方面提供对口地区教育策略支持，
              并实现一批示范校的建立。
              </div>
          </div>
        </div>
        
        <div class="right-box flex-align">
          <div class="title">
            <h3>双优云桥</h3> 
          </div>
          <div class="items">
              <div class="item">
                <div class="icon-box">
                  <img src="@/assets/yunqiao/syyq/icon01.png" alt="">
                </div>
                <h3>北京市优质资源</h3>
              </div>
               <div class="item">
                <div class="icon-box">
                  <img src="@/assets/yunqiao/syyq/icon02.png" alt="">
                </div>
                <h3>对口地区优质资源</h3>
              </div>
               <div class="item">
                <div class="icon-box">
                  <img src="@/assets/yunqiao/syyq/icon03.png" alt="">
                </div>
                <h3>首师大优质资源</h3>
              </div>
               <div class="item">
                <div class="icon-box">
                  <img src="@/assets/yunqiao/syyq/icon02.png" alt="">
                </div>
                <h3>对口地区优质资源</h3>
              </div>
          </div>
        </div>
        

      </div>
      <div class="content-bottom">
        <h2>
          首都师范大学“双优云桥”项目
        </h2>
         <div class="line flex-align-around">
             <img src="@/assets/yunqiao/syyq/line.png" alt="">
             <img src="@/assets/yunqiao/syyq/line.png" alt="">
             <img src="@/assets/yunqiao/syyq/line.png" alt="">
         </div>
         <div class="container flex-layout">
            <div class="items flex-layout">
              <div class="item"> 名校联盟<br>双师课堂</div>
              <div class="item"> 一带一路<br>共读工程</div>
              <div class="item">全学科互联网+<br>项目式学习</div>
            </div>
            <div class="items flex-layout">
              <div class="item"> 名校联盟<br>双师课堂</div>
              <div class="item"> 一带一路<br>共读工程</div>
             <div class="item">全学科互联网+<br>项目式学习</div>
            </div>
            <div class="items flex-layout">
             <div class="item"> 名校联盟<br>双师课堂</div>
              <div class="item"> 一带一路<br>共读工程</div>
              <div class="item">全学科互联网+<br>项目式学习</div>
            </div>
        </div>
      </div>
     
     
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  mounted(){
    window.scroll(0,0)
  },
  activated(){
    window.scroll(0,0)
  }
};
</script>

<style lang="less">
@import "./less/detail_syyq.less";
</style>